import { fromJS } from 'immutable';
import { CLEAR_ALT_TEXT, CLEAR_FILES, FILE_RECEIVED, FILE_UPLOAD_CALL, FILE_UPLOAD_STATUS, SET_ALT_TEXT } from '@instructure/quiz-common';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fromJS({});
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CLEAR_ALT_TEXT:
      return state["delete"]('altText');
    case CLEAR_FILES:
      return state["delete"]('files');
    case FILE_RECEIVED:
      // TODO: Have an option for adding multiple files
      return state.set('files', action.payload.file);
    case FILE_UPLOAD_CALL:
      return state.set('files', action.payload.file);
    case FILE_UPLOAD_STATUS:
      return state.set('status', action.payload.status);
    case SET_ALT_TEXT:
      return state.set('altText', action.payload.altText);
    default:
      return state;
  }
});